import React from 'react';
import { Icon, Tooltip, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { SettingsHeading } from '../../../SidebarMenu/styles';
import { DESIGN_AREA_SETTINGS_TAB } from '../../../SidebarMenu/translationValues';
import AccessibilitySummaryEditor from '../../../SidebarMenu/AccessibilitySummaryEditor';
import { useAccessibilitySettings } from '../hooks/useAccessibilitySettings';
import { checkSessionUserAccess } from '../../../../utils/helper';
import { useSessionContext } from '../../../../context/sessionContext';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];

export const AccessibilitySection = ({ CurrentDesign, readOnly, showTooltip = true, customStyles }) => {
  const { t } = useTranslation(NAMESPACES);
  const { isAccessible, summary, onAccessibleChange, onDocumentSummarySave } = useAccessibilitySettings();
  
  const sessionSelector = React.useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);

  return (
    <>
      {!checkSessionUserAccess(userDetails, 'master') && CurrentDesign === 'document' && !readOnly && (
        <SettingsHeading complexDesign style={customStyles}>
          {t(
            DESIGN_AREA_SETTINGS_TAB.ACCESSIBILITY_LABEL.key,
            DESIGN_AREA_SETTINGS_TAB.ACCESSIBILITY_LABEL.value,
          )}{' '}
          {showTooltip && (
            <Tooltip
              placement="topLeft"
              title={t(
                DESIGN_AREA_SETTINGS_TAB.ACCESSIBILITY_TOOLTIP.key,
                DESIGN_AREA_SETTINGS_TAB.ACCESSIBILITY_TOOLTIP.value,
              )}
            >
              <Icon type="question-circle" />
            </Tooltip>
          )}
          <Switch checked={isAccessible} onChange={onAccessibleChange} />
        </SettingsHeading>
      )}
      {CurrentDesign === 'document' && (
        <>
          <SettingsHeading complexDesign style={customStyles}>
            {t(DESIGN_AREA_SETTINGS_TAB.DOCUMENT_SUMMARY_LABEL.key, DESIGN_AREA_SETTINGS_TAB.DOCUMENT_SUMMARY_LABEL.value)}{' '}
            {showTooltip && (
              <Tooltip
                placement="topLeft"
                title={t(DESIGN_AREA_SETTINGS_TAB.DOCUMENT_SUMMARY_TOOLTIP.key, DESIGN_AREA_SETTINGS_TAB.DOCUMENT_SUMMARY_TOOLTIP.value)}
              >
                <Icon type="question-circle" />
              </Tooltip>
            )}
          </SettingsHeading>
          <AccessibilitySummaryEditor
            itemUUID={'document-summary'}
            contents={summary?.contents}
            customContainerStyle={{ marginTop: 10 }}
            onSaveChanges={onDocumentSummarySave}
            customizeHistory={false}
            customClassName={'summary-editor'}
          />
        </>
      )}
    </>
  );
};


